import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import axios from "axios";

import Swal from "sweetalert2";

import {
  FiArrowLeft,
  FiGlobe,
  FiMail,
  FiPhone,
  FiMapPin,
  FiFileText,
  FiBriefcase,
  FiCheckCircle,
  FiShield,
  FiUser,
  FiCalendar,
  FiBuilding,
  FiEdit2,
  FiRefreshCw,
} from "react-icons/fi";

import Sidebar from "../Layout/Sidebar";

import Header from "../Layout/Header";

import { API_BASE } from "../../../ApiUrl";

import "./Profile.css";

import {
  CollapsibleSection,
  DetailItem,
  StatusBadge,
  LegalEntitiesTable,
  TaxRegistrationsTable,
  LocationsGrid,
  RepresentativesGrid,
  DocumentsGrid,
  LegalAcceptancesList,
  OperationsTable,
} from "./ViewTenantCompo.js";

const Profile = () => {
  const navigate = useNavigate();

  const [tenantData, setTenantData] = useState(null);
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    // Get user info from localStorage
    const userData = localStorage.getItem("tenant_user");

    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);

        setUserInfo(parsedUser);

        console.log("Tenant User Info:", parsedUser);
        console.log("Tenant Id:", parsedUser.tenant_id);

        // Use tenant_id from logged-in user
        if (parsedUser.tenant_id) {
          fetchTenantDetails(parsedUser.tenant_id);
          fetchVerificationStatus(parsedUser.tenant_id);
        } else {
          Swal.fire(
            "Error",
            "Tenant ID not found. Please log in again.",
            "error"
          );

          setLoading(false);
        }
      } catch (error) {
        console.error("Error parsing user data:", error);

        Swal.fire(
          "Error",
          "Failed to parse user data. Please log in again.",
          "error"
        );

        setLoading(false);
      }
    } else {
      Swal.fire(
        "Error",
        "User data not found. Please log in again.",
        "error"
      );

      setLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ---------------------------------------------------------
  // Fetch Tenant Details
  // ---------------------------------------------------------
  const fetchTenantDetails = async (id) => {
    setLoading(true);

    try {
      const res = await axios.get(
        `${API_BASE}/tenants/${id}/stage1-details/`
      );

      console.log("Tenant Details API Response:", res);
      console.log("Tenant Details Data:", res.data?.data);

      if (res.data?.success) {
        setTenantData(res.data.data);
      } else {
        Swal.fire(
          "Error",
          "Unable to fetch tenant details.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching tenant details:", error);

      Swal.fire(
        "Error",
        error.response?.data?.message ||
          "Failed to fetch tenant details.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // ---------------------------------------------------------
  // Fetch Latest Verification Status
  // ---------------------------------------------------------
  const fetchVerificationStatus = async (id) => {
    try {
      const res = await axios.get(
        `${API_BASE}/tenant-verifications/`
      );

      console.log(
        "Tenant Verifications API Response:",
        res
      );

      console.log(
        "Tenant Verifications Data:",
        res.data?.data
      );

      if (
        res.data?.success &&
        Array.isArray(res.data?.data)
      ) {
        // Filter only verification records
        // belonging to the logged-in tenant
        const tenantVerifications = res.data.data.filter(
          (verification) =>
            Number(verification.tenant) === Number(id)
        );

        console.log("Current Tenant ID:", id);

        console.log(
          "Filtered Tenant Verifications:",
          tenantVerifications
        );

        if (tenantVerifications.length > 0) {
          // Sort by created_at DESC
          // and get the latest record
          const latestVerification = [
            ...tenantVerifications,
          ].sort(
            (a, b) =>
              new Date(b.created_at).getTime() -
              new Date(a.created_at).getTime()
          )[0];

          console.log(
            "Latest Tenant Verification:",
            latestVerification
          );

          console.log(
            "Latest Verification Status:",
            latestVerification.status
          );

          setVerificationStatus(latestVerification);
        } else {
          console.log(
            "No verification records found for tenant:",
            id
          );

          setVerificationStatus(null);
        }
      } else {
        console.log(
          "No verification data available."
        );

        setVerificationStatus(null);
      }
    } catch (error) {
      console.error(
        "Error fetching verification status:",
        error
      );

      console.error(
        "Verification API Error Response:",
        error.response?.data
      );

      setVerificationStatus(null);
    }
  };

  // ---------------------------------------------------------
  // Date Format
  // ---------------------------------------------------------
  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  // ---------------------------------------------------------
  // Date Time Format
  // ---------------------------------------------------------
  const formatDateTime = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // ---------------------------------------------------------
  // Edit Profile Visibility
  // ---------------------------------------------------------
  const shouldShowEditProfile = () => {
    /*
      Rules:

      APPROVED -> Hide Edit Profile
      REJECTED -> Hide Edit Profile

      RETURNED -> Show Edit Profile
      PENDING  -> Show Edit Profile

      If there is no verification record,
      fallback to tenant.status.
    */

    const status = (
      verificationStatus?.status ||
      tenantData?.tenant?.status ||
      ""
    ).toUpperCase();

    console.log(
      "Current Profile Status:",
      status
    );

    if (
      status === "APPROVED" ||
      status === "REJECTED"
    ) {
      return false;
    }

    if (
      status === "RETURNED" ||
      status === "PENDING"
    ) {
      return true;
    }

    // Default:
    // If status is something else, don't show edit
    return false;
  };

  // ---------------------------------------------------------
  // Loading
  // ---------------------------------------------------------
  if (loading) {
    return (
      <div className="app-layout">
        <Sidebar />

        <div className="main-content">
          <Header />

          <div className="vt-loader-container">
            <div className="vt-loader"></div>

            <p>Loading profile details...</p>
          </div>
        </div>
      </div>
    );
  }

  // ---------------------------------------------------------
  // Tenant Data Not Found
  // ---------------------------------------------------------
  if (!tenantData?.tenant) {
    return (
      <div className="app-layout">
        <Sidebar />

        <div className="main-content">
          <Header />

          <div className="vt-empty">
            <FiFileText />

            <h3>Tenant details not found</h3>

            <p>
              Please contact support if you believe this is
              an error.
            </p>

            <button
              className="vt-btn vt-btn-primary"
              onClick={() => window.location.reload()}
            >
              <FiRefreshCw />
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ---------------------------------------------------------
  // Tenant Data
  // ---------------------------------------------------------
  const {
    tenant,
    legal_entities = [],
    tax_registrations = [],
    locations = [],
    authorised_representatives = [],
    documents = [],
    legal_acceptances = [],
    operations = [],
    users = [],
  } = tenantData;

  // Get first user from Stage 1 response
  const adminUser = users?.[0] || null;

  // Determine whether Edit Profile should be visible
  const showEditProfile = shouldShowEditProfile();

  return (
    <div className="app-layout">
      <Sidebar />

      <div className="main-content">
        <Header />

        <div className="page-content vt-page">

          {/* =====================================================
              Page Header
          ===================================================== */}
          <div className="vt-page-header">
            <div className="vt-header-left">
           

              <div>
                <h2>My Profile</h2>

                <p>
                  Complete information of {tenant.name}
                </p>
              </div>
            </div>

            <div className="vt-header-actions">

              {/* Tenant / Latest Verification Status */}
              {(verificationStatus?.status ||
                tenant.status) && (
                <StatusBadge
                  status={
                    verificationStatus?.status ||
                    tenant.status
                  }
                />
              )}

              {/* =================================================
                  Edit Profile

                  APPROVED -> Hidden
                  REJECTED -> Hidden
                  RETURNED -> Visible
                  PENDING -> Visible
              ================================================= */}
              {showEditProfile && (
                <button
                  className="vt-btn vt-btn-primary"
                  onClick={() =>
                    navigate("/tenant/profile/edit")
                  }
                >
                  <FiEdit2 />
                  Edit Profile
                </button>
              )}
            </div>
          </div>

          {/* =====================================================
              Verification Status Info
          ===================================================== */}
          {verificationStatus && (
            <div className="vt-verification-info">

              <div className="vt-verification-item">
                <span>Verification Status:</span>

                <StatusBadge
                  status={verificationStatus.status}
                />
              </div>

              {verificationStatus.reason && (
                <div className="vt-verification-item">
                  <span>Reason:</span>

                  <p>
                    {verificationStatus.reason}
                  </p>
                </div>
              )}

              {verificationStatus.reviewed_at && (
                <div className="vt-verification-item">
                  <span>Reviewed At:</span>

                  <p>
                    {formatDateTime(
                      verificationStatus.reviewed_at
                    )}
                  </p>
                </div>
              )}

              {verificationStatus.created_at && (
                <div className="vt-verification-item">
                  <span>Submitted At:</span>

                  <p>
                    {formatDateTime(
                      verificationStatus.created_at
                    )}
                  </p>
                </div>
              )}
            </div>
          )}

          {/* =====================================================
              Overview
          ===================================================== */}
          <div className="vt-overview-card">
            <div className="vt-profile">

              {/* Logo */}
              <div className="vt-logo">
                {tenant.logo ? (
                  <img
                    src={
                      tenant.logo.startsWith("http")
                        ? tenant.logo
                        : `${API_BASE.replace(
                            /\/api\/?$/,
                            ""
                          )}${tenant.logo}`
                    }
                    alt={tenant.name}
                    onError={(e) => {
                      e.target.style.display =
                        "none";
                    }}
                  />
                ) : (
                  <span>
                    {tenant.name
                      ?.charAt(0)
                      .toUpperCase()}
                  </span>
                )}
              </div>

              {/* Profile Information */}
              <div className="vt-profile-info">
                <h1>{tenant.name}</h1>

                <div className="vt-admin-contact">

                  {/* Email */}
                  <div>
                    <FiMail />

                    <span>
                      {adminUser?.email || "-"}
                    </span>
                  </div>

                  {/* Mobile */}
                  <div>
                    <FiPhone />

                    <span>
                      {adminUser
                        ? `${adminUser.mobile_country_code || "+91"} ${
                            adminUser.mobile_number ||
                            ""
                          }`.trim()
                        : "-"}
                    </span>
                  </div>

                </div>
              </div>
            </div>

            {/* Overview Details */}
            <div className="vt-overview-details">

              <div>
                <span>Workspace Type</span>

                <strong>
                  {tenant.workspace_type || "-"}
                </strong>
              </div>

              <div>
                <span>Organisation Type</span>

                <strong>
                  {tenant.organisation_type || "-"}
                </strong>
              </div>

              <div>
                <span>Currency</span>

                <strong>
                  {tenant.default_currency || "-"}
                </strong>
              </div>

              <div>
                <span>Timezone</span>

                <strong>
                  {tenant.default_timezone || "-"}
                </strong>
              </div>

            </div>
          </div>

          {/* =====================================================
              Basic Information
          ===================================================== */}
          <CollapsibleSection
            icon={<FiFileText />}
            title="Basic Information"
            accent="indigo"
          >
            <div className="vt-details-grid">

              <DetailItem
                label="Legal Name"
                value={tenant.legal_name}
              />

              <DetailItem
                label="Trade Name"
                value={tenant.trade_name}
              />

              <DetailItem
                label="Tenant Code"
                value={tenant.code}
              />

              <DetailItem
                label="Contact Email"
                value={tenant.contact_email}
              />

              <DetailItem
                label="Contact Phone"
                value={tenant.contact_phone}
              />

              <DetailItem
                label="Portal Slug"
                value={tenant.portal_slug}
              />

              <DetailItem
                label="Custom Domain"
                value={
                  tenant.custom_domain || "-"
                }
              />

              <DetailItem
                label="Industry IDs"
                value={
                  tenant.industry_ids?.length
                    ? tenant.industry_ids.join(", ")
                    : "-"
                }
              />

              <DetailItem
                label="Service Scope IDs"
                value={
                  tenant.service_scope_ids?.length
                    ? tenant.service_scope_ids.join(", ")
                    : "-"
                }
              />

            </div>

            {/* Website */}
            {tenant.website && (
              <div className="vt-link-row">
                <FiGlobe />

                <a
                  href={tenant.website}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {tenant.website}
                </a>
              </div>
            )}

            {/* Description */}
            <div className="vt-description">
              <span>Description</span>

              <p>
                {tenant.description || "-"}
              </p>
            </div>
          </CollapsibleSection>

          {/* =====================================================
              Legal Entities
          ===================================================== */}
          <CollapsibleSection
            icon={<FiBriefcase />}
            title="Legal Entities"
            count={legal_entities.length}
            accent="violet"
            defaultOpen={false}
          >
            <LegalEntitiesTable
              entities={legal_entities}
              formatDate={formatDate}
              formatDateTime={formatDateTime}
            />
          </CollapsibleSection>

          {/* =====================================================
              Tax Registrations
          ===================================================== */}
          <CollapsibleSection
            icon={<FiFileText />}
            title="Tax Registrations"
            count={tax_registrations.length}
            accent="amber"
            defaultOpen={false}
          >
            <TaxRegistrationsTable
              taxRegistrations={tax_registrations}
            />
          </CollapsibleSection>

          {/* =====================================================
              Locations
          ===================================================== */}
          <CollapsibleSection
            icon={<FiMapPin />}
            title="Locations"
            count={locations.length}
            accent="rose"
            defaultOpen={false}
          >
            <LocationsGrid
              locations={locations}
            />
          </CollapsibleSection>

          {/* =====================================================
              Authorised Representatives
          ===================================================== */}
          <CollapsibleSection
            icon={<FiShield />}
            title="Authorised Representatives"
            count={
              authorised_representatives.length
            }
            accent="cyan"
            defaultOpen={false}
          >
            <RepresentativesGrid
              representatives={
                authorised_representatives
              }
              formatDate={formatDate}
            />
          </CollapsibleSection>

          {/* =====================================================
              Documents
          ===================================================== */}
          <CollapsibleSection
            icon={<FiFileText />}
            title="Documents"
            count={documents.length}
            accent="emerald"
            defaultOpen={false}
          >
            <DocumentsGrid
              documents={documents}
              formatDate={formatDate}
            />
          </CollapsibleSection>

          {/* =====================================================
              Legal Acceptances
          ===================================================== */}
          <CollapsibleSection
            icon={<FiCheckCircle />}
            title="Legal Acceptances"
            count={legal_acceptances.length}
            accent="fuchsia"
            defaultOpen={false}
          >
            <LegalAcceptancesList
              acceptances={legal_acceptances}
              formatDateTime={formatDateTime}
            />
          </CollapsibleSection>

          {/* =====================================================
              Operations
          ===================================================== */}
          <CollapsibleSection
            icon={<FiGlobe />}
            title="Operations"
            count={operations.length}
            accent="blue"
            defaultOpen={false}
          >
            <OperationsTable
              operations={operations}
              formatDate={formatDate}
            />
          </CollapsibleSection>

        </div>
      </div>
    </div>
  );
};

export default Profile;